// import { Box, useMediaQuery } from '@mui/material';
// import { DataGrid, GridToolbar } from '@mui/x-data-grid';
// import React, { memo, useEffect, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import Header from '../../../components/Header';
// import { useTheme } from '@emotion/react';
// import { tokens } from '../../../theme';
// import { getstoreItems, getstoreUsers, getWarhouseData, maxMinAvgPrice } from '../../../redux/slice/store.slice';

// // Modified ItemsDataGrid to include initialState for sorting
// const ItemsDataGrid = memo(({ data, columns }) => {
//   if (!data || !Array.isArray(data)) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <DataGrid
//       rows={data}
//       columns={columns}
//       components={{ Toolbar: GridToolbar }}
//       pageSize={5}
//       rowsPerPageOptions={[5, 10]}
//       getRowId={(row) => row._id}
//       filterMode="client"
//       density="compact"
//       initialState={{ // Set initial sort order
//         sorting: {
//           sortModel: [{ field: 'totalUnitPrice', sort: 'desc' }],
//         },
//       }}
//       sx={{
//         "@media print": {
//           "& .MuiDataGrid-toolbarContainer": {
//             display: "none !important"
//           },
//           "& .MuiDataGrid-root": {
//             color: "black !important",
//           },
//           "& .MuiDataGrid-cell": {
//             color: "black !important",
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             color: "black !important",
//           },
//           "& .MuiDataGrid-footerContainer": {
//             color: "black !important",
//           },
//           "& .css-7ms3qr-MuiTablePagination-displayedRows": {
//             color: "black !important",
//           },
//         },
//       }}
//     />
//   );
// });

// function Items() {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const dispatch = useDispatch();
//   const userId = localStorage.getItem('id');
//   const user = useSelector(state => state.store.users)?.find(u => u._id == userId);
//   const isSuperAdmin = user?.roleData?.[0]?.roleName === "Super Admin";
//   const store = useSelector(state => state.store.storee);

//   const maxMinAvg = useSelector(state => state.store.maxMinAvg);

//   console.log(maxMinAvg);


//   useEffect(() => {
//     dispatch(getstoreUsers());
//     dispatch(maxMinAvgPrice());
//     if (isSuperAdmin) {
//       dispatch(getstoreItems());
//     } else if (userId) { // Added check for userId for clarity/safety
//       dispatch(getWarhouseData(userId));
//     }
//   }, [dispatch, userId, isSuperAdmin]);

//   const stores = useMemo(() => {
//     if (!store || !Array.isArray(store)) {
//       return [];
//     }

//     // Helper to format prices, ensuring robustness
//     const formatPrice = (price) => {
//       if (price == null || isNaN(Number(price))) return '0'; // Default for null/undefined/NaN
//       price = Number(price); // Ensure it's a number before toFixed
//       return price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
//     };

//     const formatNullablePriceString = (price) => {
//         if (price == null || isNaN(Number(price))) return ''; // Default for parts of a composed string like unitPrice
//         price = Number(price);
//         return price % 1 === 0 ? String(price) : price.toFixed(2);
//     };

//     const mappedData = store.map((v, index) => {
//       let totalRecieveQtyForStore = 0;

//       // Simplified and robust calculation for totalRecieveQtyForStore
//       if (isSuperAdmin) {
//         totalRecieveQtyForStore = Array.isArray(v.storeDetails)
//           ? v.storeDetails.filter(v1 => !v1.transfer)
//                            .reduce((acc, v2) => acc + (v2.totalRecieveQtyForStore || 0), 0)
//           : 0;
//       } else {
//         totalRecieveQtyForStore = Array.isArray(v.storeDetails)
//           ? v.storeDetails.reduce((acc, v1) => acc + (v1.totalRecieveQtyForStore || 0), 0)
//           : 0;
//       }

//       const currentTotalRecieveQty = v.totalRecieveQty != null ? Number(v.totalRecieveQty) : 0;

//       return {
//         _id: (index + 1).toString(), // Assuming this ID generation is intended. If v has v._id, use that.
//         categoryName: v.categoryName || '',
//         subCategoryName: v.subCategoryName || '',
//         productName: v.productName || '',
//         unitOfMeasurement: v.unitOfMeasurement || '',
//         unitPrice: `${formatNullablePriceString(v.minUnitPrice)},${formatNullablePriceString(v.maxUnitPrice)},${formatNullablePriceString(v.avgUnitPrice)}`,
//         lastRecieveUnitPrice: v.lastRecieveUnitPrice != null ? String(v.lastRecieveUnitPrice) : '',
//         totalRecieveQtyForStore: totalRecieveQtyForStore,
//         totalRecieveQty: currentTotalRecieveQty,
//         recieveQty: Array.isArray(v.storeDetails) 
//             ? v.storeDetails.reduce((total, detail) => total + (detail.totalRecieveQty || 0), 0) 
//             : 0,
//         outwardStock: totalRecieveQtyForStore - currentTotalRecieveQty,
//         totalUnitPrice: formatPrice(v.totalUnitPrice), // This will be used for sorting
//         totalGSTAmount: formatPrice(v.totalGSTAmount),
//         finalAmount: formatPrice(v.finalAmount),
//         Desacription: v.Desacription || '',
//       };
//     });

//     // No manual sort needed here; DataGrid's initialState will handle it.
//     return mappedData;
//   }, [store, isSuperAdmin]); // Added isSuperAdmin as it's used in the mapping logic

//   const columns = useMemo(() => [
//     {
//       field: 'categoryName',
//       headerName: 'Category',
//       width: 200,
//       filterable: true,
//     },
//     {
//       field: 'subCategoryName',
//       headerName: 'Subcategory',
//       width: 160,
//       filterable: true,
//     },
//     {
//       field: 'productName',
//       headerName: 'Product Name',
//       width: 300,
//       filterable: true,
//     },
//     {
//       field: 'unitOfMeasurement',
//       headerName: 'Unit of Measurement',
//       width: 160,
//       filterable: true,
//     },
//     {
//       field: 'unitPrice',
//       headerName: 'Unit Price (Min,Max,Avg)',
//       width: 200,
//       renderCell: (params) => {
//         const prices = params.value.split(',');
//         return (
//           <div>
//             {prices[0]} , {prices[1]} , <strong>{prices[2]}</strong>
//           </div>
//         );
//       },
//     },
//     {
//       field: 'lastRecieveUnitPrice',
//       headerName: 'Last Purchase Price',
//       width: 160,
//       filterable: true,
//     },
//     {
//       field: 'totalRecieveQtyForStore',
//       headerName: 'Inward Stock ',
//       width: 130,
//       type: 'number', // Good to specify type for numeric data
//     },
//     {
//       field: 'outwardStock',
//       headerName: 'Outward Stock',
//       width: 130,
//       type: 'number', // Good to specify type for numeric data
//     },
//     {
//       field: 'totalRecieveQty',
//       headerName: 'RM Stock ', // Assuming RM means "Raw Material" or similar
//       width: 130,
//       type: 'number', // Good to specify type for numeric data
//     },
//     {
//       field: 'totalUnitPrice',
//       headerName: 'Amount', // This is the column to be sorted
//       width: 150,
//       type: 'number', // Important for correct numerical sorting by DataGrid
//     },
//     {
//       field: 'totalGSTAmount',
//       headerName: 'GST',
//       width: 150,
//       type: 'number', // Good to specify type for numeric data
//     },
//     {
//       field: 'finalAmount',
//       headerName: 'Total Amount',
//       width: 150,
//       type: 'number', // Good to specify type for numeric data
//     },
//     {
//       field: 'Desacription', // Typo: Description?
//       headerName: 'Description', // Corrected typo
//       width: 300
//     },
//   ], []);

//   return (
//     <Box m="2px">
//       <Header
//         title="ITEMS"
//         subtitle="Manage Your Items Here"
//       />
//       <Box
//         height="90vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.blueAccent[700],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: colors.primary[400],
//           },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[700],
//           },
//           "& .MuiCheckbox-root": {
//             color: `${colors.greenAccent[200]} !important`,
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//             fontSize: "13px !important",
//           },
//         }}
//       >
//         <ItemsDataGrid data={stores} columns={columns} />
//       </Box>
//     </Box>
//   )
// }

// export default Items;


// // [
// //   { $unwind: "$multipleQty" },
// //   {
// //     $group: {
// //       _id: "$multipleQty.productName",
// //       totalQty: { $sum: "$multipleQty.TotalQty" },
// //       totalValue: {
// //         $sum: {
// //           $multiply: ["$multipleQty.TotalQty", "$multipleQty.unitPrice"]
// //         }
// //       },
// //       maxPrice: { $max: "$multipleQty.unitPrice" },
// //       minPrice: { $min: "$multipleQty.unitPrice" }
// //     }
// //   },
// //   {
// //     $addFields: {
// //       avgPrice: {
// //         $cond: [
// //           { $ne: ["$totalQty", 0] },
// //           { $divide: ["$totalValue", "$totalQty"] },
// //           0
// //         ]
// //       }
// //     }
// //   },
// //   {
// //     $lookup: {
// //       from: "products", // Replace with your actual products collection name
// //       localField: "_id",
// //       foreignField: "_id",
// //       as: "productInfo"
// //     }
// //   },
// //   {
// //     $unwind: "$productInfo"
// //   },
// //   {
// //     $project: {
// //       _id: 0,
// //       productId: "$_id",
// //       productName: "$productInfo.productName", // Adjust this field based on your products schema
// //       maxPrice: 1,
// //       minPrice: 1,
// //       avgPrice: { $round: ["$avgPrice", 2] }
// //     }
// //   }
// // ]


// import { Box, useMediaQuery } from '@mui/material';
// import { DataGrid, GridToolbar } from '@mui/x-data-grid';
// import React, { memo, useEffect, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import Header from '../../../components/Header';
// import { useTheme } from '@emotion/react';
// import { tokens } from '../../../theme';
// import { getstoreItems, getstoreUsers, getWarhouseData, maxMinAvgPrice } from '../../../redux/slice/store.slice';

// // Modified ItemsDataGrid to include initialState for sorting
// const ItemsDataGrid = memo(({ data, columns }) => {
//   if (!data || !Array.isArray(data)) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <DataGrid
//       rows={data}
//       columns={columns}
//       components={{ Toolbar: GridToolbar }}
//       pageSize={5}
//       rowsPerPageOptions={[5, 10]}
//       getRowId={(row) => row._id} // Ensure row._id is unique and stable
//       filterMode="client"
//       density="compact"
//       initialState={{ // Set initial sort order
//         sorting: {
//           sortModel: [{ field: 'totalUnitPrice', sort: 'desc' }],
//         },
//       }}
//       sx={{
//         "@media print": {
//           "& .MuiDataGrid-toolbarContainer": {
//             display: "none !important"
//           },
//           "& .MuiDataGrid-root": {
//             color: "black !important",
//           },
//           "& .MuiDataGrid-cell": {
//             color: "black !important",
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             color: "black !important",
//           },
//           "& .MuiDataGrid-footerContainer": {
//             color: "black !important",
//           },
//           "& .css-7ms3qr-MuiTablePagination-displayedRows": {
//             color: "black !important",
//           },
//         },
//       }}
//     />
//   );
// });

// function Items() {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const dispatch = useDispatch();
//   const userId = localStorage.getItem('id');
//   const user = useSelector(state => state.store.users)?.find(u => u._id == userId);
//   const isSuperAdmin = user?.roleData?.[0]?.roleName === "Super Admin";
//   const store = useSelector(state => state.store.storee); // Main store data array
//   const maxMinAvgData = useSelector(state => state.store.maxMinAvg); // Data from maxMinAvgPrice()

//   // console.log("maxMinAvgData from selector:", maxMinAvgData); // Good for debugging structure


//   console.log("storestore", store, maxMinAvgData);


//   useEffect(() => {
//     dispatch(getstoreUsers());
//     dispatch(maxMinAvgPrice()); // Fetches the max/min/avg price data
//     if (isSuperAdmin) {
//       dispatch(getstoreItems());
//     } else if (userId) {
//       dispatch(getWarhouseData(userId));
//     }
//   }, [dispatch, userId, isSuperAdmin]);

//   const formatPrice = (price) => {
//     if (price == null || isNaN(Number(price))) return '0';
//     price = Number(price);
//     return price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
//   };

//   const stores = useMemo(() => {
//     if (!store || !Array.isArray(store)) {
//       return [];
//     }



//     const formatNullablePriceString = (price) => {
//       if (price == null || isNaN(Number(price))) return '';
//       price = Number(price);
//       return price % 1 === 0 ? String(price) : price.toFixed(2);
//     };

//     // Prepare maxMinAvgData for efficient lookup.
//     // Handles if maxMinAvgData is an array of objects or a single object.
//     let maxMinAvgLookup = {};
//     if (Array.isArray(maxMinAvgData)) {
//       maxMinAvgLookup = maxMinAvgData.reduce((acc, item) => {
//         if (item && item.productId) { // Ensure item and productId exist
//           acc[item.productId] = item;
//         }
//         return acc;
//       }, {});
//     } else if (maxMinAvgData && maxMinAvgData.productId) { // Single object case
//       maxMinAvgLookup = { [maxMinAvgData.productId]: maxMinAvgData };
//     }

//     const mappedData = store.map((v, index) => {
//       let totalRecieveQtyForStore = 0;
//       if (isSuperAdmin) {
//         console.log("v.storeDetails", v.storeDetails);
        
//         totalRecieveQtyForStore = Array.isArray(v.storeDetails)
//           ? v.storeDetails.filter(v1 => v1)
//             .reduce((acc, v2) => acc + (v2.totalRecieveQty || 0), 0)
//           : 0;
//       } else {
//         totalRecieveQtyForStore = Array.isArray(v.storeDetails)
//           ? v.storeDetails.reduce((acc, v1) => acc + (v1.totalRecieveQtyForStore || 0), 0)
//           : 0;
//       }

//       const currentTotalRecieveQty = v.totalRecieveQty != null ? Number(v.totalRecieveQty) : 0;

//       // Assuming v._id is the field in your store items that matches maxMinAvgData.productId
//       // If it's another field like v.productId, use that: const productIdentifier = v.productId;
//       const productIdentifier = v.productId;
//       const specificProductPrices = maxMinAvgLookup[productIdentifier];

//       let minP = 0, maxP = 0, avgP = 0;

//       if (specificProductPrices) {
//         minP = specificProductPrices.minPrice;
//         maxP = specificProductPrices.maxPrice;
//         avgP = specificProductPrices.avgPrice;
//       } else {
//         // Fallback to original values on 'v' if no match in maxMinAvgData
//         // or if maxMinAvgData is not yet loaded/available for this product.
//         // minP = v.minUnitPrice;
//         // maxP = v.maxUnitPrice;
//         // avgP = v.avgUnitPrice;
//       }

//       let totalUnitPrice = avgP * currentTotalRecieveQty
//       let totalGSTAmount = (totalUnitPrice * parseFloat(v.productGST)) / 100;
//       let finalAmount = totalUnitPrice + totalGSTAmount

//       console.log("avgP * totalRecieveQtyForStore", avgP , currentTotalRecieveQty);
      

//       return {
//         _id: v._id || `temp_id_${index}`, // IMPORTANT: Use actual unique ID from 'v'. Fallback if v._id is missing.
//         categoryName: v.categoryName || '',
//         subCategoryName: v.subCategoryName || '',
//         productName: v.productName || '',
//         unitOfMeasurement: v.unitOfMeasurement || '',
//         avgP: formatNullablePriceString(avgP),
//         productGST: v.productGST,
//         unitPrice: `${formatNullablePriceString(minP)},${formatNullablePriceString(maxP)},${formatNullablePriceString(avgP)}`,
//         lastRecieveUnitPrice: v.lastRecieveUnitPrice != null ? formatNullablePriceString(v.lastRecieveUnitPrice) : '',
//         totalRecieveQtyForStore: totalRecieveQtyForStore,
//         totalRecieveQty: currentTotalRecieveQty,
//         recieveQty: Array.isArray(v.storeDetails)
//           ? v.storeDetails.reduce((total, detail) => total + (detail.totalRecieveQty || 0), 0)
//           : 0,
//         outwardStock: totalRecieveQtyForStore - currentTotalRecieveQty,
//         totalUnitPrice: formatNullablePriceString(totalUnitPrice),
//         totalGSTAmount: formatNullablePriceString(totalGSTAmount),
//         finalAmount: formatNullablePriceString(finalAmount),
//         Desacription: v.Desacription || '', // Typo: "Description"?
//       };
//     });

//     return mappedData;
//   }, [store, isSuperAdmin, maxMinAvgData]); // Added maxMinAvgData to the dependency array

//   const columns = useMemo(() => [
//     {
//       field: 'categoryName',
//       headerName: 'Category',
//       width: 200,
//       filterable: true,
//     },
//     {
//       field: 'subCategoryName',
//       headerName: 'Subcategory',
//       width: 160,
//       filterable: true,
//     },
//     {
//       field: 'productName',
//       headerName: 'Product Name',
//       width: 300,
//       filterable: true,
//     },
//     {
//       field: 'unitOfMeasurement',
//       headerName: 'Unit of Measurement',
//       width: 160,
//       filterable: true,
//     },
//     {
//       field: 'unitPrice',
//       headerName: 'Unit Price (Min,Max,Avg)',
//       width: 200,
//       renderCell: (params) => {
//         if (!params.value) return ''; // Handle cases where unitPrice might be ",,"
//         const prices = params.value.split(',');
//         return (
//           <div>
//             {prices[0] || 'N/A'} , {prices[1] || 'N/A'} , <strong>{prices[2] || 'N/A'}</strong>
//           </div>
//         );
//       },
//     },
//     {
//       field: 'lastRecieveUnitPrice',
//       headerName: 'Last Purchase Price',
//       width: 160,
//       filterable: true,
//     },
//     {
//       field: 'totalRecieveQtyForStore',
//       headerName: 'Inward Stock ',
//       width: 130,
//       type: 'number',
//     },
//     {
//       field: 'outwardStock',
//       headerName: 'Outward Stock',
//       width: 130,
//       type: 'number',
//     },
//     {
//       field: 'totalRecieveQty',
//       headerName: 'RM Stock ',
//       width: 130,
//       type: 'number',
//     },
//     {
//       field: 'totalUnitPrice',
//       headerName: 'Amount',
//       width: 150,
//       type: 'number',
//       // renderCell: (params) => {
//       //   if (!params.row) return ''; // Handle cases where unitPrice might be ",,"

//       //   console.log("params.value", params);
        
//       //   const price = formatPrice(parseFloat(params.row.avgP) * params.row.totalRecieveQty);
//       //   return (
//       //     <div>
//       //       {price}
//       //     </div>
//       //   );
//       // },
//     },
//     {
//       field: 'totalGSTAmount',
//       headerName: 'GST',
//       width: 150,
//       type: 'number',
//       // renderCell: (params) => {
//       //   if (!params.row) return ''; // Handle cases where unitPrice might be ",,"
//       //   const price = formatPrice(parseFloat(params.row.avgP) * parseFloat(params.row.productGST));
//       //   return (
//       //     <div>
//       //       {price}
//       //     </div>
//       //   );
//       // },
//     },
//     {
//       field: 'finalAmount',
//       headerName: 'Total Amount',
//       width: 150,
//       // renderCell: (params) => {
//       //   if (!params.row) return ''; // Handle cases where unitPrice might be ",,"
//       //   const price1 = formatPrice(parseFloat(params.row.avgP) * parseFloat(params.row.productGST));
//       //   const price2 = formatPrice(parseFloat(params.row.avgP) * params.row.totalRecieveQty);
//       //   return (
//       //     <div>
//       //       {price1 + price2}
//       //     </div>
//       //   );
//       // },
//     },
//     {
//       field: 'Desacription', // Typo: Should be Description?
//       headerName: 'Description', // Corrected typo
//       width: 300
//     },
//   ], []);

//   return (
//     <Box m="2px">
//       <Header
//         title="ITEMS"
//         subtitle="Manage Your Items Here"
//       />
//       <Box
//         height="90vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.blueAccent[700],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: colors.primary[400],
//           },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[700],
//           },
//           "& .MuiCheckbox-root": {
//             color: `${colors.greenAccent[200]} !important`,
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//             fontSize: "13px !important",
//           },
//         }}
//       >
//         {/* Ensure ItemsDataGrid receives columns that are correctly memoized */}
//         <ItemsDataGrid data={stores} columns={columns} />
//       </Box>
//     </Box>
//   )
// }

// export default Items;

import { Box, useMediaQuery } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useTheme } from '@emotion/react';
import { tokens } from '../../../theme';
import { getstoreItems, getstoreUsers, getWarhouseData, maxMinAvgPrice } from '../../../redux/slice/store.slice';

// Modified ItemsDataGrid to include initialState for sorting
const ItemsDataGrid = memo(({ data, columns }) => {
  if (!data || !Array.isArray(data)) {
    return <div>Loading...</div>;
  }

  return (
    <DataGrid
      rows={data}
      columns={columns}
      components={{ Toolbar: GridToolbar }}
      pageSize={5}
      rowsPerPageOptions={[5, 10]}
      getRowId={(row) => row._id} // Ensure row._id is unique and stable
      filterMode="client"
      density="compact"
      initialState={{ // Set initial sort order
        sorting: {
          sortModel: [{ field: 'totalUnitPrice', sort: 'desc' }],
        },
      }}
      sx={{
        "@media print": {
          "& .MuiDataGrid-toolbarContainer": {
            display: "none !important"
          },
          "& .MuiDataGrid-root": {
            color: "black !important",
          },
          "& .MuiDataGrid-cell": {
            color: "black !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            color: "black !important",
          },
          "& .MuiDataGrid-footerContainer": {
            color: "black !important",
          },
          "& .css-7ms3qr-MuiTablePagination-displayedRows": {
            color: "black !important",
          },
        },
      }}
    />
  );
});

function Items() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  const userId = localStorage.getItem('id');
  const user = useSelector(state => state.store.users)?.find(u => u._id == userId);
  const isSuperAdmin = user?.roleData?.[0]?.roleName === "Super Admin";
  const store = useSelector(state => state.store.storee); // Main store data array
  const maxMinAvgData = useSelector(state => state.store.maxMinAvg); // Data from maxMinAvgPrice()

  // console.log("maxMinAvgData from selector:", maxMinAvgData); // Good for debugging structure


  console.log("storestore", store, maxMinAvgData);


  useEffect(() => {
    dispatch(getstoreUsers());
    dispatch(maxMinAvgPrice()); // Fetches the max/min/avg price data
    if (isSuperAdmin) {
      dispatch(getstoreItems());
    } else if (userId) {
      dispatch(getWarhouseData(userId));
    }
  }, [dispatch, userId, isSuperAdmin]);

  const formatPrice = (price) => {
    if (price == null || isNaN(Number(price))) return '0';
    price = Number(price);
    return price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
  };

  const stores = useMemo(() => {
    if (!store || !Array.isArray(store)) {
      return [];
    }



    const formatNullablePriceString = (price) => {
      if (price == null || isNaN(Number(price))) return '';
      price = Number(price);
      return price % 1 === 0 ? String(price) : price.toFixed(2);
    };

    // Prepare maxMinAvgData for efficient lookup.
    // Handles if maxMinAvgData is an array of objects or a single object.
    let maxMinAvgLookup = {};
    if (Array.isArray(maxMinAvgData)) {
      maxMinAvgLookup = maxMinAvgData.reduce((acc, item) => {
        if (item && item.productId) { // Ensure item and productId exist
          acc[item.productId] = item;
        }
        return acc;
      }, {});
    } else if (maxMinAvgData && maxMinAvgData.productId) { // Single object case
      maxMinAvgLookup = { [maxMinAvgData.productId]: maxMinAvgData };
    }

    const mappedData = store.map((v, index) => {
      let totalRecieveQtyForStore = 0;
      if (isSuperAdmin) {
        if (v.productName === "Vikram NDCR Topcon 595 Wp"){
console.log("v.storeDetails", v.storeDetails);
        }
        
        
        totalRecieveQtyForStore = Array.isArray(v.storeDetails)
          ? v.storeDetails.filter(v1 => !v1.transfer)
            .reduce((acc, v2) => acc + (v2.totalRecieveQtyForStore || 0), 0)
          : 0;
      } else {
        totalRecieveQtyForStore = Array.isArray(v.storeDetails)
          ? v.storeDetails.reduce((acc, v1) => acc + (v1.totalRecieveQtyForStore || 0), 0)
          : 0;
      }

      const currentTotalRecieveQty = v.totalRecieveQty != null ? Number(v.totalRecieveQty) : 0;

      // Assuming v._id is the field in your store items that matches maxMinAvgData.productId
      // If it's another field like v.productId, use that: const productIdentifier = v.productId;
      const productIdentifier = v.productId;
      const specificProductPrices = maxMinAvgLookup[productIdentifier];

      let minP = 0, maxP = 0, avgP = 0;

      if (specificProductPrices) {
        minP = specificProductPrices.minPrice;
        maxP = specificProductPrices.maxPrice;
        avgP = specificProductPrices.avgPrice;
      } else {
        // Fallback to original values on 'v' if no match in maxMinAvgData
        // or if maxMinAvgData is not yet loaded/available for this product.
        // minP = v.minUnitPrice;
        // maxP = v.maxUnitPrice;
        // avgP = v.avgUnitPrice;
      }

      let totalUnitPrice = avgP * currentTotalRecieveQty
      let totalGSTAmount = (totalUnitPrice * parseFloat(v.productGST)) / 100;
      let finalAmount = totalUnitPrice + totalGSTAmount

      console.log("avgP * totalRecieveQtyForStore", avgP , currentTotalRecieveQty);
      

      return {
        _id: v._id || `temp_id_${index}`, // IMPORTANT: Use actual unique ID from 'v'. Fallback if v._id is missing.
        categoryName: v.categoryName || '',
        subCategoryName: v.subCategoryName || '',
        productName: v.productName || '',
        unitOfMeasurement: v.unitOfMeasurement || '',
        avgP: formatNullablePriceString(avgP),
        productGST: v.productGST,
        unitPrice: `${formatNullablePriceString(minP)},${formatNullablePriceString(maxP)},${formatNullablePriceString(avgP)}`,
        lastRecieveUnitPrice: v.lastRecieveUnitPrice != null ? formatNullablePriceString(v.lastRecieveUnitPrice) : '',
        totalRecieveQtyForStore: totalRecieveQtyForStore,
        totalRecieveQty: currentTotalRecieveQty,
        recieveQty: Array.isArray(v.storeDetails)
          ? v.storeDetails.reduce((total, detail) => total + (detail.totalRecieveQty || 0), 0)
          : 0,
        outwardStock: totalRecieveQtyForStore - currentTotalRecieveQty,
        totalUnitPrice: formatNullablePriceString(totalUnitPrice),
        totalGSTAmount: formatNullablePriceString(totalGSTAmount),
        finalAmount: formatNullablePriceString(finalAmount),
        Desacription: v.Desacription || '', // Typo: "Description"?
      };
    });

    // Filter logic: If not Super Admin and totalRecieveQty is 0, filter out the record
    return isSuperAdmin 
      ? mappedData 
      : mappedData.filter(item => Number(item.totalRecieveQty) > 0);

  }, [store, isSuperAdmin, maxMinAvgData]); // Added maxMinAvgData to the dependency array

  const columns = useMemo(() => [
    {
      field: 'categoryName',
      headerName: 'Category',
      width: 200,
      filterable: true,
    },
    {
      field: 'subCategoryName',
      headerName: 'Subcategory',
      width: 160,
      filterable: true,
    },
    {
      field: 'productName',
      headerName: 'Product Name',
      width: 300,
      filterable: true,
    },
    {
      field: 'unitOfMeasurement',
      headerName: 'Unit of Measurement',
      width: 160,
      filterable: true,
    },
    {
      field: 'unitPrice',
      headerName: 'Unit Price (Min,Max,Avg)',
      width: 200,
      renderCell: (params) => {
        if (!params.value) return ''; // Handle cases where unitPrice might be ",,"
        const prices = params.value.split(',');
        return (
          <div>
            {prices[0] || 'N/A'} , {prices[1] || 'N/A'} , <strong>{prices[2] || 'N/A'}</strong>
          </div>
        );
      },
    },
    {
      field: 'lastRecieveUnitPrice',
      headerName: 'Last Purchase Price',
      width: 160,
      filterable: true,
    },
    {
      field: 'totalRecieveQtyForStore',
      headerName: 'Inward Stock ',
      width: 130,
      type: 'number',
    },
    {
      field: 'outwardStock',
      headerName: 'Outward Stock',
      width: 130,
      type: 'number',
    },
    {
      field: 'totalRecieveQty',
      headerName: 'RM Stock ',
      width: 130,
      type: 'number',
    },
    {
      field: 'totalUnitPrice',
      headerName: 'Amount',
      width: 150,
      type: 'number',
      // renderCell: (params) => {
      //   if (!params.row) return ''; // Handle cases where unitPrice might be ",,"

      //   console.log("params.value", params);
        
      //   const price = formatPrice(parseFloat(params.row.avgP) * params.row.totalRecieveQty);
      //   return (
      //     <div>
      //       {price}
      //     </div>
      //   );
      // },
    },
    {
      field: 'totalGSTAmount',
      headerName: 'GST',
      width: 150,
      type: 'number',
      // renderCell: (params) => {
      //   if (!params.row) return ''; // Handle cases where unitPrice might be ",,"
      //   const price = formatPrice(parseFloat(params.row.avgP) * parseFloat(params.row.productGST));
      //   return (
      //     <div>
      //       {price}
      //     </div>
      //   );
      // },
    },
    {
      field: 'finalAmount',
      headerName: 'Total Amount',
      width: 150,
      // renderCell: (params) => {
      //   if (!params.row) return ''; // Handle cases where unitPrice might be ",,"
      //   const price1 = formatPrice(parseFloat(params.row.avgP) * parseFloat(params.row.productGST));
      //   const price2 = formatPrice(parseFloat(params.row.avgP) * params.row.totalRecieveQty);
      //   return (
      //     <div>
      //       {price1 + price2}
      //     </div>
      //   );
      // },
    },
    {
      field: 'Desacription', // Typo: Should be Description?
      headerName: 'Description', // Corrected typo
      width: 300
    },
  ], []);

  return (
    <Box m="2px">
      <Header
        title="ITEMS"
        subtitle="Manage Your Items Here"
      />
      <Box
        height="90vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
            fontSize: "13px !important",
          },
        }}
      >
        {/* Ensure ItemsDataGrid receives columns that are correctly memoized */}
        <ItemsDataGrid data={stores} columns={columns} />
      </Box>
    </Box>
  )
}

export default Items;